// Globals that don't get more things jammed onto them, so they should
// be safe to import directly from their npm modules.
// We should eliminate these globals modules once we:
// 1. Get CommonsChunkPlugin set up
// 2. Perform explicit imports everywhere we use them
import moment from '@rover/globals/moment';
import Url from '@rover/globals/domurl';
import Mustache from '@rover/globals/Mustache';
import _ from '@rover/globals/underscore';

// Globals that our code gloms things on top of
import jQuery from '@rover/globals/jquery';
import Backbone from '@rover/globals/backbone';

// Globals that are typically setup in the template
import Rover from '@rover/globals/Rover';
import dataLayer from '@rover/globals/dataLayer';



// WEBPACK FOOTER //
// ./js/globals.js